<template lang="pug">
    .container.cardVisualizar
        .card
          .card-body
            informacoes-conversa(
              :idConversa="idConversa",
              :voltar="'/manutencao/encerrar-conversa'",
              @statusChanged="setStatus"
            )
        el-row.voltar-container
          app-buttons-cadastro(
            :isPrimeiroPasso="false",
            :isUltimoPasso="true",
            :showButtonFinalizar="false"
            :showButtonEnviar="false"
            :showButtonCancelar="false"
            @voltar="voltar"
          )
    </template>

<script>
import InformacoesConversa from '@/screens/central/components/comunicacao/InformacoesConversa'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppButtonsCadastro from '@/components/AppButtonsCadastro'

export default {
  mixins: [
    AppNotificacao
  ],
  components: {
    InformacoesConversa,
    AppButtonsCadastro
  },
  data () {
    return {
      idConversa: this.$route.params.idConversa,
      statusConversa: null
    }
  },
  methods: {
    voltar () {
      this.$router.push({
        name: 'ENCERRAR_CONVERSA_MANUTENCAO'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
    .container {
      padding: 20px;
      flex-direction: column;
    }
    .footer-buttons {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 15px;
    }
    .voltar-container {
      padding: 0px 20px 30px 20px;
    }
    .responder {
      margin-right: 5px;
    }
    .finalizar-conversa {
      margin-left: 5px;
    }

    @media (max-width: 780px) {
      .card {
        position: relative;
        left: 20px;
        width: 315px;
      }

      .container {
        position: relative;
        top: 35px;
      }

      .cardVisualizar {
        top: 60px;
        right: 65%;
      }
    }
</style>



// WEBPACK FOOTER //
// src/screens/manutencao/VisualizarConversa.vue